class WhiteGlove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const trigger = this.querySelector(".white-glove-table-trigger");
    const tableWrap = this.querySelector(".white-glove-table-wrap");
    const closeBtn = this.querySelector(".white-glove-table-close");

    if (trigger && tableWrap && closeBtn) {
      trigger.addEventListener("click", () => {
        tableWrap.classList.remove("hidden");
      });

      closeBtn.addEventListener("click", () => {
        tableWrap.classList.add("hidden");
      });
    }
  }
}

customElements.define("white-glove", WhiteGlove);
